import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { salesPrimaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sales/constants";
import { TestimonialsBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { TestimonialsBlock1 as Block } from "./TestimonialsBlock1";
import { defaultData } from "./TestimonialsBlock1DefaultData";
import imagePreview from "./testimonials_block_1_preview.png";

export const TestimonialsBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Testimonials Block 1",
    nameI18n: "builder_ui.block_type.testimonials.block_1",
    version: 1,
    category: [TestimonialsBlock],
    props: {
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            defaultValue: "var(--theme-website-color-background-secondary)",
            category: [DesignProp, GeneralProp],
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            defaultValue: salesPrimaryBlockDefaultStyles.padding,
            category: [DesignProp, PaddingsProp],
          },
          margin: {
            ...margin,
            defaultValue: salesPrimaryBlockDefaultStyles.margin,
            category: [DesignProp, MarginsProp],
          },
        },
      },
    },
  },
};
